import { Component } from 'js-component-framework';
import { AriaPopup } from 'js-component-framework/lib/plugins';
import './search.scss';

/**
 * Component for search flyout
 */
export default class Search extends Component {
  static clickHandler(event, popup) {
    event.preventDefault();
    event.stopPropagation();
    popup.ariaToggle(event);
    document.body.classList.toggle('searching');
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  init() {
    const {
      controller,
      focusElement,
      target,
      closeButton,
    } = this.children;

    const {
      options: {
        ariapopup: attributes,
      },
    } = this;

    if (! controller || ! target) {
      return;
    }

    this.popup = new AriaPopup({
      controller,
      target,
      attributes,
    });

    this.popup.controller.addEventListener('click', (e) => Search
      .clickHandler(e, this.popup));

    closeButton.addEventListener('click', (e) => Search
      .clickHandler(e, this.popup));

    this.element.addEventListener('popupshow', () => {
      focusElement.focus();
    });

    this.element.addEventListener('popuphide', () => {
      document.body.classList.remove('searching');
    });
  }
}
